import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCiscoComponent } from './simple-icons-cisco.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCiscoComponent ],
    exports:      [ SimpleIconsCiscoComponent ],
    bootstrap:    []
})
export class SimpleIconsCiscoModule {}
